<template>
  <div class="custom-radio-group" :class="[disabledAll ? 'disabledAll' : '']">
    <label v-for="(item, index) in optionProps" :key="index" class="custom-radio"
      :class="[disabledAll ? 'disabledAll' : '']">
      <input type="radio" :value="item.value" v-model="valueInput" class="input_radio" 
        :class="[item.value == valueInput ? 'checked' : '']" 
        :name="item?.name ? item?.name : 'radio-in'" :disabled="disabledAll" />
      <span class="radio-mark" :class="[disabledAll ? 'disabledAll' : '']"></span>
      {{ item.label }}
    </label>
  </div>
</template>
<script>
import { watch, ref } from "vue";

export default {
  name: "InputRadio",
  emits: ["update:modelValue"],
  props: {
    optionProps: {
      type: Array,
      required: true
    },
    modelValue: [Number, String],
    disabledAll: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
  const valueInput = ref(props.modelValue);

  // Emit when local value changes
  watch(valueInput, (val) => {
    emit("update:modelValue", val);
  });

  // Watch for parent value changes
  watch(() => props.modelValue, (newVal) => {
    valueInput.value = newVal;
  });

  return { valueInput };
}

};
</script>


<style lang="scss" scoped>
@import "./InputRadio.scss";

.disabledAll {
  cursor: default;
  pointer-events: none;
}
</style>
